import { Component, ChangeDetectionStrategy } from '@angular/core';

/** Planche en cases : une grille de 3 × 3 cases. */
@Component({
    selector: 'vw-bed-cells-icon',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<svg width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="6" height="6" rx="1.2"/><rect x="9" y="2" width="6" height="6" rx="1.2"/><rect x="16" y="2" width="6" height="6" rx="1.2"/>
    <rect x="2" y="9" width="6" height="6" rx="1.2"/><rect x="9" y="9" width="6" height="6" rx="1.2"/><rect x="16" y="9" width="6" height="6" rx="1.2"/>
    <rect x="2" y="16" width="6" height="6" rx="1.2"/><rect x="9" y="16" width="6" height="6" rx="1.2"/><rect x="16" y="16" width="6" height="6" rx="1.2"/>
    </svg>`
})
export class BedCellsIconComponent {
}
